export function normalizeNavigationRoute(route: string | null | undefined): string {
  if (!route) return ''
  const trimmed = route.trim()
  if (!trimmed) return ''
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}

export function normalizeNavigationRouteKey(route: string | null | undefined): string {
  return normalizeNavigationRoute(route).toLowerCase()
}
